import styled from 'styled-components';

export const SubmitInput = styled.input`
    padding: 0 24px;
    height: 48px;
    line-height: 18.75px;
    border-radius: 6px;
    border: none;
    outline: none;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    width: 100%;

    transition: background-color 0.3s ease;
    will-change: background-color;

    color: white;
    background-color: ${({ theme }): string => theme.button.action.default.background};

    &:hover {
        background-color: ${({ theme }): string => theme.button.action.hover.background};
    }

    &:disabled {
        background-color: ${({ theme }): string => theme.button.action.disabled.background};
    }
`;
